export const ACTIVITIES_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'activity',
  'activity_type',
  'public_agent_module_permission',
  'group_module_permission',
]
